// extracted by mini-css-extract-plugin
export default {"centered":"Register_centered__boRRK"};